import {Component, Input} from '@angular/core';
import {NavController, NavParams } from 'ionic-angular';
import {DishServices} from "../../services";

/**
 * Generated class for the DishViewGraphicsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-dish-view-graphics',
    templateUrl: 'dish-view-graphics.html',
})
export class DishViewGraphicsPage {
    @Input() dish: any;

    constructor(public navCtrl: NavController,
                public navParams: NavParams,
                public dishServices: DishServices,
               ) {
    }

}



// WEBPACK FOOTER //
// ./src/pages/dish/dish-view/dish-view-graphics/dish-view-graphics.ts